import router from ".";

export function getRouteObj(name, arr){
    arr.forEach(item => {
        const obj = {
            path: item.path,
            name: item.menuname,
            component: () => import(`@/views/${item.component}`),
            meta: {
                pageTitle: item.title,
                title: item.title,
                ...JSON.stringify(item.props)
            }
        };
        if(item.children.length){
            getRouteObj(item.menuname, item.children);
        }
        name ? router.addRoute(name, obj) : router.addRoute(obj);
    })
}